import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { ApiService } from "src/app/services/api.service";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ContentActionComponent } from "src/app/shared/content-action/content-action.component";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ActivatedRoute, Router } from "@angular/router";
import { Confirmation } from "src/app/enums/confirmation.enum";
import { FormControl, FormGroup } from "@angular/forms";
import { FilterFormModal } from "src/app/models/form-group.model";
import { MatTabChangeEvent } from "@angular/material/tabs";
import endpoints from "src/app/helpers/endpoints";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'fury-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  animations: [fadeInRightAnimation, fadeInUpAnimation],
})
export class ContactComponent implements OnInit, OnDestroy {

  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  @Input()
  columns = [
    // { name: "status", property: "status", visible: true },
    { name: "Name", property: "name", visible: true },
    { name: "Mobile Number", property: "mobileNumber", visible: true },
    { name: "Email", property: "emailAddress", visible: true },
    { name: "Department", property: "department", visible: true },
    { name: "Zip Code", property: "zipCode", visible: true },
    { name: "Message", property: "message", visible: true },
    { name: "Actions", property: "actions", visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;

  tabNameList = {
    0: "New",
    1: "In Progress",
    2: "Completed"
  }
  tabName = this.tabNameList[0];
  isActive: any = null;
  ngUnsubscribe = new Subject<void>();
  searchValue: any = {};
  isLoading = false;
  searchForm = new FormGroup({
    name: new FormControl(""),
    mobileNumber: new FormControl(""),
    emailAddress: new FormControl(""),
    message: new FormControl(""),
    department: new FormControl(""),
    zipCode: new FormControl(""),
    status: new FormControl(""),
  });

  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.filterValue = "Contact List";
    this.router.onSameUrlNavigation = "reload";
  }

  ngOnInit() {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.pageIndex = res.page ? res.page - 1 : 0;
        this.pageSize = res.size ? (res.size === "all" ? 9999 : res.size) : 30;
        this.getContacts();
      });
  }

  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/contacts?page=${this.pageIndex + 1}${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }`
    );
  }

  getContacts() {
    this.isLoading = true;
    this.apiservice
      .get(
        `${endpoints.contact.getContacts}?page=${Number(this.pageIndex) + 1}&size=${
          this.pageSize
        }&name=${this.searchValue?.name || ""}&mobileNumber=${this.searchValue?.mobileNumber || ""}&emailAddress=${
          this.searchValue?.emailAddress || ""
        }&department=${this.searchValue?.department || ""}&message=${
          this.searchValue?.message || ""
        }&zipCode=${this.searchValue?.zipCode || ""}&status=${this.searchValue?.status || ""}&tabName=${this.tabName || ""}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          if (res.body) {
            this.isLoading = false;
            if (res.body.contacts.data) {
              this.itemList = res.body.contacts.data;
              this.totalCount = res.body.contacts.total;
              this.dataSource = new MatTableDataSource(this.itemList);
              this.cdr.detectChanges();
            } else {
              this.itemList = undefined;
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.apiservice.alert(err.message, ErrorType.Error);
        }
      );
  }
  openDialog(type: string, id: string) {
    const dialogRef = this.dialog.open(ContentActionComponent, {
      width: "500px",
      data: { type },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: Confirmation) => {
        if (res === Confirmation.Yes) {
          this.apiservice
            .delete(`admin/user/delete-user/${id}`)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
              next: (del: any) => {
                if (del.body) {
                  this.apiservice.alert(del.body.message, ErrorType.Success);
                  this.getContacts();
                }
              },
              error: (err: HttpErrorResponse) => {
                if (err) {
                  this.apiservice.alert(err?.message, ErrorType.Error);
                }
              },
            });
        }
      });
  }

 
  tabChangeHandle(event: MatTabChangeEvent) {
    this.pageIndex = 0;
    this.tabName = this.tabNameList[event.index];
    this.searchForm.updateValueAndValidity();
    this.searchForm.setValue(this.searchForm.value as any);
    this.getContacts();
  }
  search(event: any) {
    this.searchValue = event;
    this.getContacts();
  }
  fetchContact(event: any) {
    this.getContacts();
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
